<template>
  <div class="main layout">
    <Layout>
      <Sider hide-trigger :style="{ background: '#fff' }">
        <div class="sider-header logo">
          <img src="../assets/images/eKuiper-logo.png" alt="kuiper-logo" width="35" />
          <span>eKuiper</span>
        </div>
        <Leftbar></Leftbar>
        <div class="sider-footer">
          <div v-if="!isIEF" class="footer-item">
            <a rel="noopener" target="_blank" href="https://github.com/lf-edge/ekuiper">
              <Icon type="logo-github"></Icon> GitHub
            </a>
          </div>
          <div class="footer-item" v-if="!isFabric">
            <a href="javascript:;" @click="handleLogout">
              <Icon type="md-exit"></Icon>
            </a>
            {{ user.username }}
          </div>
        </div>
      </Sider>
      <Layout :style="{ padding: '36px 24px 24px' }">
        <router-view></router-view>
        <section v-if="isFlow" class="flow-wrap">
          <Button type="text" icon="ios-arrow-back" @click="goBack">{{ $t('common.back') }}</Button>
          <main>
            <div id="flow-container"></div>
            <Spin v-if="isLoadingFlowSubApp" size="large" fix></Spin>
          </main>
        </section>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import store from '@/store/index'
import Leftbar from '@/components/Leftbar.vue'
import { clearLocalStorage } from '@/utils/localStorage'
import { isSubAppFlowPath } from '@/utils/forSubAppFlow'
import nodeID from '@/mixins/nodeID'

export default {
  name: 'Main',

  mixins: [nodeID],

  components: {
    Leftbar,
  },

  data() {
    return {
      breadcrumbTitle: {
        stream: this.$t('streams.stream'),
        rules: this.$t('rules.rules'),
        plugins: this.$t('plugins.plugins'),
        nodes: this.$t('nodes.nodes'),
      },
    }
  },

  computed: {
    isFlow() {
      return isSubAppFlowPath(this.$route.path)
    },
    isLoadingFlowSubApp() {
      return store.state.isLoadingSubApp
    },
    isIEF() {
      return this.$store.state.isIEF
    },
    isFabric() {
      return this.$store.state.isFabric
    },
    user() {
      return this.$store.state.user
    },
    currentPage() {
      const pageName = this.$route.path.split('/')[1]
      return this.breadcrumbTitle[pageName]
    },
    currentAcessTitle() {
      const { id } = this.$route.params
      const { oper } = this.$route.query
      if (!id) {
        return this.$t('common.listPage')
      }
      if (id === '0' && oper === 'create') {
        return this.$t('common.create')
      }
      return this.$t('common.view')
    },
  },

  methods: {
    handleLogout() {
      this.$router.push({ path: '/login' })
      clearLocalStorage()
    },
    goBack() {
      this.$router.push({
        name: 'rules',
        params: {
          id: this.nodeID,
        },
      })
    },
  },

  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.commit('SET_NODE_ID_FOR_FABRIC', to.params.id)
    }
    next()
  },
}
</script>

<style lang="scss">
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.layout-logo {
  width: 100px;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 20px;
}
.logo {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  span {
    color: #00b173;
    font-weight: 600;
    font-size: 18px;
    margin-left: 16px;
  }
}
.ivu-layout-sider-children {
  position: relative;
}
.sider-footer {
  position: absolute;
  bottom: 0;
  font-size: 14px;
  padding: 10px 20px !important;
  .footer-item {
    height: 22px;
    line-height: 22px;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  color: #ffffff;
  .ivu-icon {
    font-size: 20px;
    color: #a8acb6;
    margin-right: 16px;
  }
  a {
    color: #ffffff;
    &:hover {
      color: #ffffff;
    }
  }
}
</style>
